import { ConditionRegistryItem } from '../../ConditionRegistryItem';
import { ConditionRegistryCategory } from '../../ConditionRegistryCategory';
export class ConditionRegistryQuestionTask extends ConditionRegistryCategory {
    label = 'Task';
    constructor(parent) {
        super(parent);
        super.init();
    }
    isTaskCompleted = () => new ConditionRegistryItem({
        /*  label: 'Task fertig beantwortet', */
        eval: ({ task }) => !!task && task.taskProgress.isTaskCompleted
    });
    isTaskFinished = () => new ConditionRegistryItem({
        /*  label: 'Beantwortung des Tasks abgeschlossen', */
        eval: ({ task }) => !!task && task.taskProgress.isTaskFinished
    });
}
